import { Component, effect, EventEmitter, Input, OnChanges, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormioCustomComponent, FormioEvent } from '@app/shared/elements.common';


@Component({
  standalone: false,
  selector: 'app-custom-slider',
  templateUrl: './custom-slider.component.html',
  styleUrls: ['./custom-slider.component.scss']
})
export class CustomSliderComponent implements OnInit, FormioCustomComponent<any>, OnChanges {
  @Input() value: any;
  @Input() disabled: boolean = false;
  @Input() name: string = '';
  
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() formioEvent = new EventEmitter<FormioEvent>();

  sliderForm!: FormGroup;
  min: number = 10;
  max: number = 100;
  cappedValue = 90;
  step: number = 1;
  disableSlider: boolean = true;
  labels = [10, 20, 30, 40, 50, 60, 70, 80, 90, "Max"];
  hoursSignal = signal<number>(0);
  sliderValue : number = this.min;
  
  get sliderMax(): number {
    // If value exceeds cappedValue, extend slider to show actual value
    return Math.max(this.max, this.sliderValue);
  }


  constructor(private fb: FormBuilder) {
    // console.log(this.value,this.disabled,this.name, this.valueChange,this.formioEvent)
    // effect(() => {
    //   const hours = this.hoursSignal();
    //   if (this.sliderForm) {
    //     this.sliderForm.get('hours')?.setValue(Number(hours), { emitEvent: false });
    //   }
    // });
  }

  ngOnInit(): void {
    // this.sliderForm = new FormGroup({
    //   hours: new FormControl(0, [Validators.min(0), Validators.max(90)])
    // });
    // Set initial value if provided
    // if (this.value) {
    //   const initialValue = typeof this.value === 'number' ? this.value : 0;
    //   this.hoursSignal.set(initialValue);
    //   this.sliderForm.get('hours')?.setValue(initialValue);
    // }
    // Emit value changes to formio
    // this.sliderForm.get('hours')?.valueChanges.subscribe(val => {
    //   this.value = val;
    //   this.valueChange.emit(val);
    // });
 
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentSliderValue = isNaN(changes?.value?.currentValue) ? this.min : changes?.value?.currentValue;
    // Set the actual value without clamping
    this.sliderValue = Math.max(this.min, Number(currentSliderValue) || this.min);
  }


  get percent(): number {
    // Calculate percentage based on actual slider range
    const range = this.sliderMax - this.min;
    const percent = ((this.sliderValue - this.min) / range) * 100;
    return percent;
  }

  onSliderChange(value: string | number): void {
    this.sliderValue = Number(value);
    this.valueChange.emit(this.sliderValue);
  }

  // getErrors() {
  //   const touchedHoursInput = this.sliderForm.get('hours')?.touched;
  //   const hours = this.sliderForm.get('hours')?.value;
  //   let err;
  //   if (hours < this.min && touchedHoursInput) {
  //     err = `minimum value should be ${this.min}`;
  //     return err;
  //   } else if (hours > this.max && touchedHoursInput) {
  //     err = `maximum eligible value is ${this.cappedValue} `;
  //     return err;
  //   }
  //   return null;
  // }
}
